export default class UserService {
	constructor() {
		this.auth = firebase.auth()
		this.ref = firebase.database().ref()
		this.usersRef = this.ref.child('users')
	}

	listenForPollIds(callback) {
		const { uid } = this.auth.currentUser
		const ref = this.usersRef.child(uid).child('polls')

		ref.off()
		ref.on('child_added', (snap) => callback(snap.key))

		return () => ref.off()
	}
}



// WEBPACK FOOTER //
// ./src/services/UserService.js